import * as React from 'react';
import { Util } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import '@swc/helpers';
import '@grandvisionhq/analytics';
import '@grandvisionhq/graphql';
import '@grandvisionhq/lib-utils-cart';
import '@grandvisionhq/svc-monetate';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/utils';
import '../../../context/Cart/context.js';
import '../../../context/CartSettings/context.js';
import { useGetCart } from '../../../hooks/use-get-cart.js';
import '../../../models/add-to-cart/add-to-cart.js';
import '../../../models/cart/cart.js';
import '../../../models/subscription/subscription-details.js';
import '../../../models/checkoutState/checkoutState.js';
import '@grandvisionhq/payments';
import '../../../mappers/analytics/tealium/line-item-to-tealium-product.js';
import '../../../utils/cart-count-var.js';
import '../../../utils/cart-id-var.js';
import '@grandvisionhq/commercetools';
import '../../../utils/get-unrecoverable-validation-errors.js';
import '../../../models/line-item/prescription-glasses.js';
import '../../../utils/get-failure-error-codes.js';
import '@grandvisionhq/lib-visuals';
import '../../../operations/fragments/cart-details.js';
import '../../../operations/fragments/cart-validation-errors.js';
import '../../../operations/fragments/recover-inactive-cart-failure.js';
import '../../../operations/fragments/recover-inactive-cart-result.js';
import '../../../operations/mutations/add-cart-line-items.js';
import '../../../operations/mutations/add-cart-voucher-codes.js';
import '../../../operations/mutations/create-cart.js';
import '../../../operations/mutations/create-cart-from-instant-checkout-link.js';
import '../../../operations/mutations/duplicate-cart-line-items.js';
import '../../../operations/mutations/remove-cart-voucher-codes.js';
import '../../../operations/mutations/remove-cart-line-items.js';
import '../../../operations/mutations/update-cart-line-items.js';
import '../../../operations/mutations/replace-line-item-contact-lenses-bundle-benelux.js';
import '../../../operations/mutations/recover-inactive-cart.js';
import '../../../operations/queries/get-cart.js';
import '../../../operations/queries/get-total-line-items.js';
import '../../../operations/queries/get-cart-estimated-delivery.js';
import '@grandvisionhq/frk-routing';
import 'classnames';
import '../../../slots/context.js';
import '../../../slots/header-slot/context.js';
import '../../../slots/sidebar-slot/context.js';
import '@grandvisionhq/elements';
import '@grandvisionhq/iris-ui';
import { Title } from '../components/Title.js';

const TitleContainer = ()=>{
    const intl = useIntl();
    const { data  } = useGetCart();
    const numberOfItems = data ? data.numberOfItems : 0;
    const value = React.useMemo(()=>{
        return Util.getCartTotalsTitle(numberOfItems, intl, 'cart.minicart.totalsTitle.singular', 'cart.minicart.totalsTitle');
    }, [
        numberOfItems,
        intl
    ]);
    return /*#__PURE__*/ React.createElement(Title, {
        value: value
    });
};

export { TitleContainer };
//# sourceMappingURL=TitleContainer.js.map
